/* =============================================================
 * Cart Toast Notification Stack
 * Standalone Alpine.js component — injected into DOM at init.
 * No toast HTML lives in index.html.
 * ============================================================= */
(function () {
    'use strict';

    const DURATION = 4000; // ms auto-dismiss
    const LEAVE_MS = 300;  // ms leave animation (must match CSS toastSlideOut)

    // ── Toast container + x-for template ─────────────────────────────────────
    const HTML = `
<div class="cart-toasts"
     x-data="cartToastStack"
     @cart-toast.window="show($event.detail)">
    <template x-for="t in items" :key="t._id">
        <div class="cart-toast"
             :class="{ 'cart-toast--paused': t._paused, 'cart-toast--leaving': t._leaving, 'cart-toast--error': t.type === 'error' }"
             @mouseenter="pause(t._id)" @mouseleave="resume(t._id)"
             role="alert" aria-live="polite">
            <button class="cart-toast__close" @click="leave(t._id)" aria-label="Закрыть">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>
            </button>
            <div class="cart-toast__img-wrap" x-show="t.img">
                <img :src="t.img || ''" :alt="t.name" class="cart-toast__img" loading="lazy">
            </div>
            <div class="cart-toast__content">
                <div class="cart-toast__added"
                     x-text="t.type === 'error' ? 'Не удалось добавить' : t.type === 'wishlist-add' ? 'Добавлено в избранное' : t.type === 'wishlist-remove' ? 'Удалено из избранного' : t.type === 'compare-add' ? 'Добавлено в сравнение' : t.type === 'compare-remove' ? 'Убрано из сравнения' : 'Добавлено в корзину'"></div>
                <div class="cart-toast__name" x-text="t.name"></div>
                <div class="cart-toast__actions">
                    <a x-show="t.type === 'cart'" :href="(window.__THEME__?.cartPageUrl || window.__THEME__?.cartUrl || '/cart/')" class="cart-toast__cta" aria-label="Перейти в корзину">Перейти в корзину</a>
                    <a x-show="t.type === 'wishlist-add'" :href="(window.__THEME__?.searchUrl || '/search/') + '?query=&view=favorite'" class="cart-toast__cta">Перейти в избранное</a>
                    <button x-show="t.type === 'wishlist-remove'" class="cart-toast__cta"
                            @click.stop="$store.wishlist.toggle(t.pid||'',t.img||'',t.name||''); leave(t._id)">Отменить</button>
                    <a x-show="t.type === 'compare-add'" :href="$store.compare.compareUrl()" class="cart-toast__cta">Перейти в сравнение</a>
                    <button x-show="t.type === 'compare-remove'" class="cart-toast__cta"
                            @click.stop="$store.compare.toggle(t.pid||'',t.img||'',t.name||''); leave(t._id)">Отменить</button>
                </div>
            </div>
            <div class="cart-toast__timer" aria-hidden="true"></div>
        </div>
    </template>
</div>`;

    document.addEventListener('alpine:init', () => {

        Alpine.data('cartToastStack', () => ({
            items: [],
            _seq:  0,

            show(d) {
                const id = ++this._seq;
                this.items.push({
                    ...d,
                    _id:      id,
                    _paused:  false,
                    _leaving: false,
                    _end:     Date.now() + DURATION,
                });
                setTimeout(() => this._autoLeave(id), DURATION);
            },

            _autoLeave(id) {
                const t = this.items.find(t => t._id === id);
                if (!t || t._leaving || t._paused) return;
                this.leave(id);
            },

            leave(id) {
                const t = this.items.find(t => t._id === id);
                if (!t || t._leaving) return;
                t._leaving = true;
                setTimeout(() => {
                    this.items = this.items.filter(t => t._id !== id);
                }, LEAVE_MS);
            },

            pause(id) {
                const t = this.items.find(t => t._id === id);
                if (t) t._paused = true;
            },

            resume(id) {
                const t = this.items.find(t => t._id === id);
                if (!t || t._leaving) return;
                t._paused = false;
                const rem = Math.max(500, t._end - Date.now());
                setTimeout(() => this._autoLeave(id), rem);
            },
        }));

        const wrapper = document.createElement('div');
        wrapper.innerHTML = HTML;
        document.body.appendChild(wrapper.firstElementChild);
    });

}());
